<template>
  <div class="home">
    <Navbar/>
    <!-- BANNER -->
    <div class="banner-home banner-anos-iniciais">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col text-center">
            <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" class="btn-duvidas" rel="noopener noreferrer">DÚVIDAS ? FALE CONOSCO</a>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-md">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-vinho" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco2" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-9 p-0">
            <div class="text-banner">
                A obra leva a educação financeira para o dia a dia do aluno de forma lúdica e acessível.
            </div>
          </div>
        </div>
        <div class="row justify-content-center btns-banner menu-sm">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-vinho" to="/anos-iniciais">Ensino Fundamental - Anos Iniciais</router-link>
              </div>
              <div class="col-md-6 text-center p-0">
                <router-link class="btn btn-branco2" to="/anos-finais">Ensino Fundamental - Anos Finais</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center carousel-home">
          <div class="col-md-11">
            <VueSlickCarousel v-bind="settings">
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/1/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin1.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/2/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin2.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin3.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/4/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin4.png" class="img-fluid mx-auto"></a>
              </div>
              <div class="">
                <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/educacao-financeira/5/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/livros/fin5.png" class="img-fluid mx-auto"></a>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
    <!-- DESTAQUE -->
    <div class="container destaque">
      <div class="row justify-content-center">
        <div class="col-md-7 text-center">
          <h1>Destaques da obra</h1>
        </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-md-9">
              <div class="row">
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/1-atividades.png" class="img-fluid mx-auto">
                        <p>Agrega de forma mista atividades participativas e de sistematização.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/2-bncc.png" class="img-fluid mx-auto">
                        <p>Desenvolve competências gerais da Educação Básica e várias habilidades da BNCC, potencializando a aprendizagem.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/3-design.png" class="img-fluid mx-auto">
                        <p>Design gráfico agradável e visualmente atrativo.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/4-linguagem.png" class="img-fluid mx-auto">
                        <p>Linguagem fácil e acessível.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/5-material.png" class="img-fluid mx-auto">
                        <p>Material do professor que propõe encaminhamentos didáticos, respostas das atividades, considerações sobre a importância da educação financeira e um quadro informativo com indicações.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/6-volumes.png" class="img-fluid mx-auto">
                        <p>Os volumes reúnem atividades sobre situações cotidianas que ressaltam a presença e a importância da educação financeira desde cedo.</p>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="box-destaque">
                        <img src="../assets/imagens/destaques/anos-iniciais/7-professor.png" class="img-fluid mx-auto">
                        <p>Cada volume distribui o conteúdo em três unidades compostas por teorias e atividades visando a exploração dos temas e a fixação do conhecimento.</p>
                    </div>
                </div>
              </div>
          </div>
      </div>
    </div>
    <!-- AUTORES -->
    <div class="container autores">
      <div class="row justify-content-center">
        <div class="col-md-10 text-center">
          <h1>Autores</h1>
          <img src="../assets/imagens/autores.png" class="img-fluid mx-auto">
          <h2>Volumes: 1, 2 e 3</h2>
          <div class="texto">
            <p class="sub-titulo">Vitor Nascimento Souza</p>
            <p>• Graduando em Ciências Biológicas no Instituto de Biociências da Universidade Estadual Paulista (Unesp), Botucatu.</p>
            <p>• Autor de materiais didáticos.</p>
          </div>
          <div class="texto">
            <p class="sub-titulo">Erdna Perugine Nahum</p>
            <p>• Graduada em História pela Faculdade de Filosofia, Letras e Ciências Humanas da Universidade de São Paulo (USP).</p>
            <p>• Mestre em História Social na Faculdade de Filosofia, Letras e Ciências Humanas da Universidade de São Paulo (USP).</p>
            <p>• Doutoranda em História Social pela Faculdade de Filosofia, Letras e Ciências Humanas da Universidade de São Paulo (USP).</p>
          </div>
          <h2>Volumes: 4</h2>
          <div class="texto">
            <p class="sub-titulo">Angela Cruz</p>
            <p>• Bacharel e licenciada em História pela Universidade Federal do Rio de Janeiro (UFRJ).</p>
            <p>• Professora da História aposentada pelo Colégio Pedro II (RJ), da rede federal de ensino.</p>
            <p>• Coautora de obras didáticas sobre juventude e trabalho.</p>
          </div>
          <div class="texto">
            <p class="sub-titulo">Mônica Waldhelm</p>
            <p>• Licenciada em Ciências Biológicas pela Universidade Federal do Rio de Janeiro (UFRJ).</p>
            <p>• Doutora em Educação pela Pontifícia Universidade Católica do Rio de Janeiro (PUC-Rio).</p>
            <p>• Professora titular aposentada do Centro Federal de Educação Tecnológica (Cefet-RJ).</p>
            <p>• Consultora em Educação com projetos desenvolvidos para a Unesco, TV Escola e outras organizações.</p>
            <p>• Coautora de livros didáticos de Ciências da Natureza e Projeto de Vida.</p>
          </div>
          <h2>Volumes: 5</h2>
          <div class="texto">
            <p class="sub-titulo">Ana Flavia Alonço Castanho</p>
            <p>• Graduada em Pedagogia pela Faculdade de Educação da Universidade de São Paulo (USP).</p>
            <p>• Mestre em Psicologia Escolar e do Desenvolvimento Humano pelo Instituto de Psicologia da Universidade de São Paulo (USP).</p>
            <p>• Professora no curso de Pedagogia e de Pós-Graduação em Didática da Matemática do Instituto Vera Cruz.</p>
            <p>• Autora de materiais didáticos.</p>
          </div>
          <div class="texto">
            <p class="sub-titulo">Maria Priscila Bacellar Monteiro</p>
            <p>• Graduada em Pedagogia pela Fatema - Faculdades Integradas Teresa Martin.</p>
            <p>• Mestre em Educação Matemática pela Pontifícia Universidade Católica de São Paulo (PUC/SP).</p>
            <p>• Professora no curso de Pedagogia e coordenadora do curso de Pós-Graduação do Instituto Vera Cruz.</p>
            <p>• Autora de materiais didáticos.</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
          "arrows": true,
          "slidesToShow": 4,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "touchMove": false,
          "responsive": [
              {
              "breakpoint": 1024,
              "settings": {
                  "slidesToShow": 4,
                  "slidesToScroll": 1
                  }
              },
              {
              "breakpoint": 600,
              "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true,
                  "variableWidth": true
                  }
              },
              {
              "breakpoint": 480,
              "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true,
                  "variableWidth": true
                  }
              }
          ]
      }
    }
  }
}
</script>
